export const POLICY_MILITARISM_UNIT_MELEE_BONUS_D6 = 1;
export const POLICY_MILITARISM_UNIT_MELEE_BONUS_D10 = 2;
export const POLICY_MILITARISM_UNIT_MELEE_BONUS_D20 = 4;
export const POLICY_MILITARISM_UNIT_MELEE_BONUS_D8 = 2;
export const POLICY_MILITARISM_UNIT_MELEE_BONUS_D12 = 4;

export const POLICY_MILITARISM_UNIT_MELEE_BONUS_WITH_MILITARY_CAMP_D6 = 2;
export const POLICY_MILITARISM_UNIT_MELEE_BONUS_WITH_MILITARY_CAMP_D10 = 3;
export const POLICY_MILITARISM_UNIT_MELEE_BONUS_WITH_MILITARY_CAMP_D20 = 5;
export const POLICY_MILITARISM_UNIT_MELEE_BONUS_WITH_MILITARY_CAMP_D8 = 3;
export const POLICY_MILITARISM_UNIT_MELEE_BONUS_WITH_MILITARY_CAMP_D12 = 5;


